<template>
  <v-row>
    <v-col
      cols="12"
      sm="6"
    >
      <v-card class="elevation-3">
        <v-card-title class="subtitle-2 primary--text grey lighten-4">
          Locatiom Details
        </v-card-title>

        <v-divider />

        <v-row class="px-3">
          <v-col
            cols="12"
            sm="6"
          >
            <v-list-item class="px-0">
              <v-list-item-avatar class="mr-1">
                <v-icon v-text="'mdi-information-outline'" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle v-text="'Location Code'" />
                <v-list-item-title v-text="details.code || 'N/A'" />
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col
            cols="12"
            sm="6"
          >
            <v-list-item class="px-0">
              <v-list-item-avatar class="mr-1">
                <v-icon v-text="'mdi-map-marker-outline'" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle v-text="'Address'" />
                <v-list-item-title v-text="details.address || 'N/A'" />
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col
            cols="12"
            sm="6"
          >
            <v-list-item class="px-0">
              <v-list-item-avatar class="mr-1">
                <v-icon v-text="'mdi-email-outline'" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle v-text="'Postcode'" />
                <v-list-item-title v-text="details.postcode || 'N/A'" />
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col
            cols="12"
            sm="6"
          >
            <v-list-item class="px-0">
              <v-list-item-avatar class="mr-1">
                <v-icon v-text="'mdi-map-marker-outline'" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle v-text="'Formatted Address'" />
                <v-list-item-title v-text="details.formatted_address || 'N/A'" />
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col
            cols="12"
            sm="6"
          >
            <v-list-item class="px-0">
              <v-list-item-avatar class="mr-1">
                <v-icon v-text="'mdi-information-outline'" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle v-text="'Latitude'" />
                <v-list-item-title v-text="details.lat || 'N/A'" />
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col
            cols="12"
            sm="6"
          >
            <v-list-item class="px-0">
              <v-list-item-avatar class="mr-1">
                <v-icon v-text="'mdi-information-outline'" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle v-text="'Longitude'" />
                <v-list-item-title v-text="details.lng || 'N/A'" />
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col
            cols="12"
            sm="6"
          >
            <v-list-item class="px-0">
              <v-list-item-avatar class="mr-1">
                <v-icon v-text="'mdi-information-outline'" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle v-text="'Is Valid'" />
                <v-list-item-title v-text="details.is_valid ? 'Yes' : 'No'" />
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-card>
    </v-col>

    <v-col
      cols="12"
      sm="6"
      class="d-none d-sm-block"
    >
      <bing-map
        id="location"
        show-push-pin
        class="lime lighten-5 elevation-3"
        :center="details.lat && details.lng ? {...details} : undefined"
      />
    </v-col>

    <template v-if="timeWindows.isLoading">
      <v-col
        class="pa-12 text-center"
        cols="12"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-col>
    </template>

    <template v-else-if="!timeWindows.list.length">
      <v-col
        class="ml-auto pb-5 text-right"
        cols="6"
        md="3"
      >
        <h-date-range-picker
          v-model="timeWindows.dateRange"
          label="Filter by Date"
          @input="fetchTimeWindows(details)"
        />
      </v-col>

      <v-col
        class="pt-5 text-center"
        cols="12"
      >
        <div class="d-flex justify-center align-center text-center grey--text">
          <div>
            <v-icon
              color="grey"
              size="100"
            >
              mdi-text-box-search-outline
            </v-icon>
            <div class="subtitle-1 black--text my-1">
              No Time Windows Available
            </div>
            <div class="caption my-1">
              Please filter by a different date
            </div>
          </div>
        </div>
      </v-col>
    </template>

    <template v-else>
      <v-col
        md="9"
        cols="6"
        align-self="end"
        class="px-5 subtitle-1 primary--text font-weight-bold"
        v-text="'The following time windows are available for the selected range'"
      />

      <v-col
        class="text-right"
        cols="6"
        md="3"
      >
        <h-date-range-picker
          v-model="timeWindows.dateRange"
          hide-details
          label="Filter by Date"
          @input="fetchTimeWindows(details)"
        />
      </v-col>

      <template v-for="date in timeWindows.list">
        <v-col
          v-if="date.time_windows.length"
          :key="date.for_date"
          xs="12"
          sm="6"
          md="4"
          lg="4"
        >
          <v-card
            class="d-flex flex-column"
            height="100%"
          >
            <v-card-title class="grey--text caption font-weight-bold grey lighten-4">
              <span class="primary--text">{{ humanizeDate(date.for_date) }}</span>
              <v-spacer />
              <div
                style="font-size: 10px"
                class="grey--text"
              >
                <span class="grey--text">Updated:</span> &nbsp;
                <span
                  class="grey--text"
                >{{ humanizeDateFromSeconds(date.last_updated, 'hh:mm DD/MM/YYYY') }}</span>
              </div>
            </v-card-title>

            <v-divider />

            <v-card-text
              class="py-0 pr-8 pl-0"
              style="max-height:300px;overflow:auto"
            >
              <v-timeline dense>
                <v-timeline-item
                  v-for="time_window in date.time_windows"
                  :key="time_window.quarter"
                  small
                >
                  <v-card
                    outlined
                    class="
                      indigo lighten-5 d-flex justify-center align-center pa-2 rounded-lg caption
                    "
                  >
                    <strong class="primary--text">
                      {{ humanizeDateFromSeconds(time_window.start) }}
                      -
                      {{ humanizeDateFromSeconds(time_window.end) }}
                    </strong>
                    <v-icon
                      color="green"
                      small
                      right
                    >
                      mdi-checkbox-marked-circle
                    </v-icon>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-card-text>
          </v-card>
        </v-col>
      </template>
    </template>
  </v-row>
</template>

<script>
import moment from 'moment';
import { storesCollection } from '@/firebase';
import BingMap from '@/components/commons/BingMap.vue';
import { fetchTimeWindows } from '@/utils/timeWindows';
import { humanizeDateFromSeconds, humanizeDate } from '@/utils/misc';
import HDateRangePicker from '@/components/commons/HDateRangePicker.vue';

function defaultDetails() {
  return {
    lng: '',
    lat: '',
    code: '',
    address: '',
    postcode: '',
    formatted_address: '',
  };
}

const defaultTimeWindowsData = {
  list: [],
  isLoading: false,
  dateRange: {
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().add(6, 'days').format('YYYY-MM-DD'),
  },
};

export default {
  components: { BingMap, HDateRangePicker },
  props: {
    details: {
      type: Object,
      default() {
        return defaultDetails();
      },
    },
  },
  data() {
    return {
      timeWindows: { ...defaultTimeWindowsData },
    };
  },
  created() {
    this.fetchTimeWindows(this.details);
  },
  methods: {
    humanizeDate,
    humanizeDateFromSeconds,
    fetchTimeWindows(store) {
      this.timeWindows.isLoading = true;

      fetchTimeWindows(
        storesCollection.doc(store.id),
        this.timeWindows.dateRange.startDate,
        this.timeWindows.dateRange.endDate,
      )
        .then((response) => {
          this.timeWindows.list = [...response].filter(
            (date) => date.time_windows.length,
          );
          this.timeWindows.isLoading = false;
        })
        .catch(() => {
          this.timeWindows.isLoading = false;
        });
    },
  },
};

</script>
